//通用类的方法都在这里哦
import config from '../config'
import {Notification} from 'element-ui';
import CryptoJS from 'crypto-js'

const API_MODE = (process.env.VUE_APP_API_MODE || 'proxy').toLowerCase()
const baseUrl = process.env.NODE_ENV === 'development' ? config.basUrl.dev : config.basUrl.pro
const DIRECT_API_HOSTS = {
  Q7FileAPI: process.env.VUE_APP_DIRECT_Q7FILEAPI || 'http://lgbzbback.erqicn.cn',
  WXmpApi: process.env.VUE_APP_DIRECT_WXMPAPI || 'http://oa.erqicn.cn',
  WXSendApi: process.env.VUE_APP_DIRECT_WXSENDAPI || 'http://oa.erqicn.cn'
}

function ensureTrailingSlash(url) {
  return url.endsWith('/') ? url : `${url}/`
}

function resolveBaseUrlByMode(rawBaseUrl) {
  if (!rawBaseUrl || API_MODE !== 'direct') {
    return rawBaseUrl
  }

  if (/^https?:\/\//i.test(rawBaseUrl)) {
    return rawBaseUrl
  }

  const match = rawBaseUrl.match(/^\/(Q7FileAPI|WXmpApi|WXSendApi)\/?$/)
  if (!match) {
    return rawBaseUrl
  }

  const targetHost = DIRECT_API_HOSTS[match[1]]
  return targetHost ? ensureTrailingSlash(targetHost) : rawBaseUrl
}

const runtimeBaseUrl = resolveBaseUrlByMode(baseUrl)

// 默认加密密钥，从环境变量获取
const DEFAULT_SECRET_KEY = process.env.VUE_APP_SECRET_KEY_SUFFIX

// 不同 API 类型的密钥配置（与后台约定一致）
const API_SECRET_KEYS = {
  wxmp: process.env.VUE_APP_WXMP_SECRET_KEY || DEFAULT_SECRET_KEY,
  wxsend: process.env.VUE_APP_WXMP_SEND_KEY || DEFAULT_SECRET_KEY,
  default: DEFAULT_SECRET_KEY
}

export default {
  //获取共用的颜色
  getcomcolor(){
    return ['#9b4aff','#fb9337','#3cd500','#409EFF','#f2637b','#9b4aff','#fb9337','#3cd500','#409EFF','#f2637b']
  },
  //获取后台路径
  getBaseUrl() {
    return runtimeBaseUrl
  },
  //时间日期格式化过滤器
  filterTime(time, type = 'datetime') {
    let date = new Date(time);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let minute = date.getMinutes();
    minute = minute < 10 ? "0" + minute : minute;
    let s = date.getSeconds();
    s = s < 10 ? "0" + s : s;
    let rettime
    if (type === 'date') {
      rettime = y + "-" + m + "-" + d;
    } else {
      rettime = y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    }
    return rettime
  },
  //根据下标获取execl的横向字母坐标头 Num to Excel letter
  numToString(number) {
    let char = "";
    let array = [];
    // Switch ASCII
    let numToStringAction = function (nnum) {
      let num = nnum - 1;
      let a = parseInt(num / 26);
      let b = num % 26;
      array.push(b);
      if (a > 0) {
        numToStringAction(a);
      }
    }
    numToStringAction(number);
    array = array.reverse();
    // Return excel letter: such => C / AA / BBA
    for (let i = 0; i < array.length; i++) {
      char += String.fromCharCode(64 + parseInt(array[i] + 1));
    }
    return char;
  },
  //通知：操作成功Notification通知
  MegSuccess(text, position = 'top-right') {
    Notification({
      title: '成功',
      message: text,
      type: 'success',
      position: position,
      offset: 100
    });
  },
  //通知：信息提示Notification通知
  Meginfo(text, position = 'top-right') {
    Notification.info({
      title: '提示',
      position: position,
      message: text
    });
  },
  //集合方法排序
  sortKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return ((y < x) ? -1 : (x > y) ? 1 : 0)//从大到小 543210
      // return ((y>x)?-1:(x<y)?1:0)//从小到大 012345
    })
  },
  //只能输入包含小数的数字方法允许负数
  ruleflaot(value) {
    value = value.replace(/\s*/g, '')
    if (value == '.') {
      value = '';
    }
    if (value.split(".").length - 1 > 1) {
      value = value.split(".")[0] + '.';
    }
    return value.replace(/[^\-?\d.]/g,'');
  },
  //只允许输入数字和英文的方法
  rulesengnumft(value) {
    value =value.replace(/[^a-zA-Z0-9]/g, '');
    return value;
  },
  //将数字值按规定保留小数位允许负数（去掉末尾多余 0）
  changeflaot(value, num) {
    var flaotval = ''
    // 修复：正确处理 0 值，0 也是有效数字
    if (value !== null && value !== undefined && value !== '') {
      const numValue = parseFloat(value.toString().replace(/[^\-?\d.]/g,''));
      // 如果解析成功（包括0），则格式化；如果解析失败（NaN），返回空字符串
      if (!isNaN(numValue)) {
        const digits = (num !== undefined && num !== null && num !== '') ? Number(num) : 0
        flaotval = numValue.toFixed(isNaN(digits) ? 0 : digits);
        // 只有当包含小数点时，才去掉小数点后末尾多余的0
        // 例如：5.200 → 5.2, 5.320 → 5.32, 但 160 → 160（不变）
        if (flaotval.includes('.')) {
          flaotval = flaotval.replace(/\.?0+$/, '');
        }
      }
    }
    return flaotval
  },
  //服务器文件下载通用方法
  downlogfile(file) {
    let url = file.url
    fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
      const a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = file.name  // 下载文件的名字
      document.body.appendChild(a)
      a.click()
    })
  },

  /**
   * 根据 apitype 获取对应的密钥
   * @param {string} apitype - API类型
   * @returns {string} - 对应的密钥
   */
  getSecretKey(apitype) {
    return API_SECRET_KEYS[apitype] || API_SECRET_KEYS.default;
  },

  /**
   * Key加密方法
   * @param {string} data - 需要加密的数据
   * @param {string} apitype - API类型，用于选择对应的密钥
   * @returns {string} - 加密后的字符串
   */
  encryptKey(data, apitype = 'default') {
    if (!data) return ''
    
    // 根据 apitype 获取对应的密钥
    const secretKey = this.getSecretKey(apitype); 
    
    // 使用 SHA256 处理密钥
    const keyHash = CryptoJS.SHA256(secretKey);
    
    // 生成随机 IV
    const iv = CryptoJS.lib.WordArray.random(16);
    
    // 使用CBC模式和PKCS7填充进行加密
    const encrypted = CryptoJS.AES.encrypt(data, keyHash, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    // 将 IV 和加密数据拼接
    const result = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
    return result;
  },

  /**
   * Key解密方法
   * @param {string} encryptedData - 加密的数据
   * @param {string} apitype - API类型，用于选择对应的密钥
   * @returns {string} - 解密后的字符串
   */
  decryptKey(encryptedData, apitype = 'default') {
    if (!encryptedData) return ''
    try {
      // 根据 apitype 获取对应的密钥
      const secretKey = this.getSecretKey(apitype);
      
      // 使用 SHA256 处理密钥
      const keyHash = CryptoJS.SHA256(secretKey);
      
      // 将Base64字符串转换为WordArray
      const ciphertext = CryptoJS.enc.Base64.parse(encryptedData);
      
      // 从密文中提取IV（前16字节）
      const iv = CryptoJS.lib.WordArray.create(ciphertext.words.slice(0, 4));
      const encryptedMessage = CryptoJS.lib.WordArray.create(ciphertext.words.slice(4));
      
      // 解密
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedMessage },
        keyHash,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      );
      
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('解密失败:', error)
      return ''
    }
  },

  /** 是否处于操作锁定中（需组件 data 中有 actionLoading 对象） */
  isActionLocked(vm, key) {
    return !!(vm && vm.actionLoading && vm.actionLoading[key])
  },

  /**
   * 防重复点击：异步操作期间锁定指定 action
   * @returns {Promise<any|undefined>} 重复点击时返回 undefined
   */
  async runWithActionLock(vm, key, fn) {
    if (!vm || !vm.actionLoading) {
      return fn()
    }
    if (vm.actionLoading[key]) {
      return undefined
    }
    vm.$set(vm.actionLoading, key, true)
    try {
      return await fn()
    } finally {
      vm.$set(vm.actionLoading, key, false)
    }
  },

  /* 防抖节流函数*/
  debounce: function (fn, delay) {
    var delays = delay || 200
    var timer
    var lastArgs
    var lastThis
    var debounced = function (...args) {
      lastArgs = args
      lastThis = this
      if (timer) clearTimeout(timer)
      timer = setTimeout(function () {
        timer = null
        fn.apply(lastThis, lastArgs)
      }, delays)
    }
    debounced.cancel = function () {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
    }
    debounced.flush = function () {
      if (!timer) return
      clearTimeout(timer)
      timer = null
      fn.apply(lastThis, lastArgs)
    }
    return debounced
  }
}
